var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.91,
    height: 48.83,
    viewBox: "0 0 42.91 48.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content-icon",
    transform: "translate(-11.55 -6.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13498",
    "data-name": "Path 13498",
    d: "M19.29,44.81H15.74a2.279,2.279,0,0,1-2.28-2.28V10.89a2.279,2.279,0,0,1,2.28-2.28H39.27a2.279,2.279,0,0,1,2.28,2.28v2.67a.96.96,0,1,0,1.92,0V10.89A4.2,4.2,0,0,0,39.28,6.7H15.74a4.2,4.2,0,0,0-4.19,4.19V42.53a4.2,4.2,0,0,0,4.19,4.19h3.55a.96.96,0,1,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13499",
    "data-name": "Path 13499",
    d: "M38.43,13.74a.96.96,0,0,0-.96-.96H16.55a.96.96,0,1,0,0,1.92H37.47A.96.96,0,0,0,38.43,13.74Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13500",
    "data-name": "Path 13500",
    d: "M19.09,19.27H16.55a.96.96,0,1,0,0,1.92h2.54a.96.96,0,1,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13501",
    "data-name": "Path 13501",
    d: "M19.09,25.75H16.55a.96.96,0,1,0,0,1.92h2.54a.96.96,0,1,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13502",
    "data-name": "Path 13502",
    d: "M19.09,32.24H16.55a.96.96,0,1,0,0,1.92h2.54a.96.96,0,0,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13503",
    "data-name": "Path 13503",
    d: "M19.09,38.73H16.55a.96.96,0,1,0,0,1.92h2.54a.96.96,0,0,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13504",
    "data-name": "Path 13504",
    d: "M50.26,17.51H26.74a4.2,4.2,0,0,0-4.19,4.19V51.34a4.2,4.2,0,0,0,4.19,4.19H50.27a4.2,4.2,0,0,0,4.19-4.19V21.7a4.2,4.2,0,0,0-4.19-4.19Zm2.28,33.83a2.279,2.279,0,0,1-2.28,2.28H26.74a2.279,2.279,0,0,1-2.28-2.28V21.7a2.279,2.279,0,0,1,2.28-2.28H50.27a2.279,2.279,0,0,1,2.28,2.28V51.34Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    d: "M27.55,25.12h8.92a.96.96,0,1,0,0-1.92H27.55a.96.96,0,1,0,0,1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M27.55,31.61h8.11a.96.96,0,1,0,0-1.92H27.55a.96.96,0,1,0,0,1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    d: "M49.45,35.18H27.55a.96.96,0,1,0,0,1.92H49.44a.96.96,0,0,0,0-1.92Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    d: "M48.09,22.38h-6.2a2.322,2.322,0,0,0-2.32,2.32v5.2a2.322,2.322,0,0,0,2.32,2.32h6.2a2.322,2.322,0,0,0,2.32-2.32V24.7a2.322,2.322,0,0,0-2.32-2.32Zm.4,7.51a.4.4,0,0,1-.4.4h-6.2a.4.4,0,0,1-.4-.4v-5.2a.4.4,0,0,1,.4-.4h6.2a.4.4,0,0,1,.4.4Z",
    fill: "#d0d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    d: "M48,40.84H29a2.407,2.407,0,0,0-2.4,2.4v5.84a2.407,2.407,0,0,0,2.4,2.4H48a2.407,2.407,0,0,0,2.4-2.4V43.24A2.407,2.407,0,0,0,48,40.84Zm.49,8.24a.491.491,0,0,1-.49.49H29a.491.491,0,0,1-.49-.49V43.24a.491.491,0,0,1,.49-.49H48a.491.491,0,0,1,.49.49Z",
    fill: "#d0d6ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/content-icon.3249848f93a952047ec3f0cba29b7074.svg";
export { ForwardRef as ReactComponent };